import { render, staticRenderFns } from "./ImageLoader.vue?vue&type=template&id=25702236&"
import script from "./ImageLoader.vue?vue&type=script&lang=js&"
export * from "./ImageLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/core-product/common/vue2/patsnap-biz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25702236')) {
      api.createRecord('25702236', component.options)
    } else {
      api.reload('25702236', component.options)
    }
    module.hot.accept("./ImageLoader.vue?vue&type=template&id=25702236&", function () {
      api.rerender('25702236', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ImageLoader.vue"
export default component.exports